import React from 'react';
import "../Figure.css"


function Figure3() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> </th>
              <th> Signal </th>
              <th> Concentration (mg/mL)</th>
              <th> Protein in 40 µL (mg)</th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Sample 1 </th>
              <td> 0.564 </td>
              <td> 0.837 / 2 </td>
              <td> 16.8 </td>
            </tr> 
            <tr>
              <th> Sample 2 </th>
              <td> 0.748 </td>
              <td> 1.185 / 2 </td>
              <td> 23.6 </td>
            </tr>
            <tr>
              <th> Sample 3 </th>
              <td> 1.129 </td>
              <td> 1.874 / 2 </td>
              <td> 37.4 </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure3;